import { Button, Flex, Input } from "@chakra-ui/react";
import React from "react";

const SellerSearchHeading = ({ setIsDrawerOpen }) => {
  return (
    <Flex justifyContent={"space-between"}>
      <Input disabled type="search" w={"40%"} placeholder="Search seller" />
      <Button
        onClick={() => setIsDrawerOpen(true)}
        variant={"solid"}
        bg="blue.600"
        color="white"
        mr={4}
        w="200px"
        _hover={{
          backgroundColor: "#054180",
        }}
      >
        Add new Seller
      </Button>
    </Flex>
  );
};

export default SellerSearchHeading;
